import React, { Component } from "react";
import PropTypes from "prop-types";
import withTranslation from "../translation";
import CountrySelectorButton from "../CountrySelectorButton";
import { ANALYTICS_POSITION_HEADER } from "../../../helpers/events";
import styles from "./MiscBar.css";
import { getMarketplaceUrl } from "../../helpers/externalLinks";
import { withParams } from "../../../helpers/queryString";
import clientConfig from "@template/clientConfig";
import getFeatureVariables from "@src/template/helpers/getFeatureVariables";

class MiscBar extends Component {
  state = {
    marketplaceVintageLinkDesktop: null
  };

  componentDidMount = async () => {
    const marketplaceVintageLinkDesktop = await getFeatureVariables(
      "emf-95-desktop-marketplace-clothing-nav-edit"
    );

    this.setState({
      marketplaceVintageLinkDesktop
    });
  };

  marketplaceUrl = marketplaceVintageLinkDesktop => {
    let additionalAnalyticsParams = "";
    if (!clientConfig.isServer()) {
      /* istanbul ignore else */
      if (marketplaceVintageLinkDesktop?.bucket === "v2") {
        additionalAnalyticsParams = "|emf95_v2_default";
      } else if (marketplaceVintageLinkDesktop?.bucket === "v1") {
        additionalAnalyticsParams = "|emf95_v1_default";
      }
    }

    const marketplaceUrlWithParams = withParams(getMarketplaceUrl(), {
      ctaref: `Global nav`
    });

    return `${marketplaceUrlWithParams}${additionalAnalyticsParams}`;
  };

  render() {
    const { formatTranslation, defaultStoreUrl } = this.props;
    const { marketplaceVintageLinkDesktop } = this.state;

    return (
      <div className={styles.container} data-testid="topbar">
        <div className={styles.body}>
          <ul className={styles.navigation}>
            <li>
              <a
                href={`${this.marketplaceUrl(marketplaceVintageLinkDesktop)}`}
                data-testid="marketplace"
                className={styles.asosFocus}
              >
                {formatTranslation("miscbar_marketplace")}
              </a>
            </li>
            <li>
              <a
                href={defaultStoreUrl.concat(
                  formatTranslation("miscbar_helplink")
                )}
                data-testid="help"
                className={styles.asosFocus}
              >
                {formatTranslation("miscbar_help")}
              </a>
            </li>
            <li>
              <CountrySelectorButton position={ANALYTICS_POSITION_HEADER} />
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

MiscBar.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  defaultStoreUrl: PropTypes.string.isRequired
};

export default withTranslation(MiscBar);
